export default "__VITE_ASSET__ZLJ$tt_4__"